import { Th } from "@lightspeed/cirrus-table";
import styled from "@emotion/styled";
import { useSelector } from "react-redux";
import { uiSelector } from "../../../redux/slices/uiSlice";
import { IconChevronUp } from "@lightspeed/flame/Icon/ChevronUp";
import { IconChevronDown } from "@lightspeed/flame/Icon/ChevronDown";
import { IconChevronUpDown } from "@lightspeed/flame/Icon/ChevronUpDown";

const StickyTh = styled(Th)`
  position: -webkit-sticky;
  position: sticky;
  top: ${({ stickyTop }) => stickyTop};
  z-index: 101;
  background: ${({ sectionBackground }) => sectionBackground || "white"};
  border-right: ${({ dividerAfter, dividerColor }) =>
    dividerAfter ? `3px solid ${dividerColor || "#88aef5"}` : "none"};
  box-shadow: inset 0 -1px 0 rgba(28, 41, 61, 0.08);
`;

const SortButton = styled.button`
  border: 0;
  background: transparent;
  padding: 0;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 6px;
  font: inherit;
  color: inherit;
  cursor: pointer;
`;

const Label = styled.span`
  display: inline-flex;
  align-items: center;
`;

const renderSortIcon = (direction) => {
  if (direction === "asc") return <IconChevronUp size="small" color="secondary" />;
  if (direction === "desc") return <IconChevronDown size="small" color="secondary" />;
  return <IconChevronUpDown size="small" color="textDimmed" />;
};

const TableHeaderItem = ({
  item,
  index,
  sortState,
  changeSortState,
  hasSectionHeaders,
}) => {
  const {
    sortable,
    id,
    width,
    label,
    sectionBackground,
    dividerAfter,
    dividerColor,
  } = item;
  const sortValues = ["unsorted", "desc", "asc"];
  const { theme } = useSelector(uiSelector);
  const stickyTop = hasSectionHeaders ? "48px" : "0";
  const direction = sortValues[sortState[index]];

  return (
    <StickyTh
      className={theme === "flame" ? "" : "dark-theme"}
      key={id}
      width={width}
      stickyTop={stickyTop}
      sectionBackground={sectionBackground}
      dividerAfter={dividerAfter}
      dividerColor={dividerColor}
    >
      {sortable ? (
        <SortButton
          type="button"
          onClick={() => {
            changeSortState(index);
          }}
        >
          <Label>{label}</Label>
          {renderSortIcon(direction)}
        </SortButton>
      ) : (
        label
      )}
    </StickyTh>
  );
};

export default TableHeaderItem;
